<template>
  <div>
    <v-card
      class="mt-5"
      color="yellow lighten-4"
    >
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <div v-html="item.content" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="primary"
          small
          text
          @click.prevent="dialogControl(item)"
          v-if="hasRole('ROLE_UPDATE_NOTE')"
        >
          {{ $t('Edit') }}
        </v-btn>
        <v-btn
          v-if="handleDeleted && hasRole('ROLE_DELETE_NOTE')"
          @click="confirmDelete = true"
          small
          class="red"
          dark
          color="danger"
        >
          {{ $t('Delete') }}
        </v-btn>
        <ConfirmDelete
          :handle-delete="del"
          :visible="confirmDelete"
          @close="confirmDelete = false"
          v-if="handleDeleted && hasRole('ROLE_DELETE_NOTE')"
        />
        <v-spacer></v-spacer>
        <v-tooltip
          v-if="item.createdAt && item.createdBy"
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-information-outline</v-icon>
            </v-btn>
          </template>
          <div>
            Erstellt: {{ formatDateTime(item.createdAt, 'L LT ') }} Uhr <br />
            von: {{ item.createdBy.profile.firstName }} {{ item.createdBy.profile.lastName }}
            <template v-if="item.updatedAt && item.createdAt !== item.updatedAt">
              <hr />
              Aktualisiert: {{ formatDateTime(item.updatedAt, 'L LT ') }} Uhr <br />
              von: {{ item.updatedBy.profile.firstName }} {{ item.updatedBy.profile.lastName }}
            </template>
          </div>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
  import { formatDateTime } from '@/utils/dates';
  import ConfirmDelete from '../ConfirmDelete';

  export default {
    name: 'Card',
    components: { ConfirmDelete },
    props: {
      item: {
        type: Object,
        required: true
      },
      handleDeleted: {
        type: Function,
        required: false
      },
    },
    data() {
      return {
        confirmDelete: false,
      }
    },

    methods: {
      formatDateTime,
      dialogControl(module) {
        console.log(this.item);

        this.$emit('showEdit', module)
      },
      del() {
        this.handleDeleted(this.item);
        this.confirmDelete = false;
      },
    },
  };
</script>
